import { Stack } from '@cast/design-system';
import { ContainersDropdown } from '../../container-select';
import { useWorkloadSelectedContainer } from '../_hooks/useWorkloadSelectedContainer';

export const WorkloadContainerSelect = () => {
  const { container, setContainerName, containers } =
    useWorkloadSelectedContainer();

  if (!container) {
    return null;
  }

  return (
    <Stack data-testid="container-select">
      <ContainersDropdown
        selectedContainer={container}
        selectContainer={(c) => setContainerName(c.name)}
        showStartAdornment
        containers={containers}
        readOnly={containers.length <= 1}
      />
    </Stack>
  );
};
